import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=48f0ae89"
import script from "./ExtraInfo.vue?vue&type=script&lang=ts"
export * from "./ExtraInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports